import { Component, Input } from '@angular/core';

import { ParticipantModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-summary-participants',
    templateUrl: './confirmation-summary-participants.component.html',
    styleUrls: ['./confirmation-summary-participants.component.scss'],
    standalone: false,
})
export class ConfirmationSummaryParticipantsComponent {
    @Input()
    public participants: ParticipantModel[];

    @Input()
    public displayMobileNumber = false;
}
